import { useState } from 'react';
import { TextField, Autocomplete, InputAdornment, Popper } from '@mui/material';
import { useToursContext } from '../../../contexts/tour-context';
import { useQuery } from '@tanstack/react-query';
import { getMapTours } from '../../../services/requests/map.services';
import { SearchOutlined } from '@mui/icons-material';
import { useRef } from 'react';
import { t } from '@lingui/macro';

export default function TourSearch({ searchParams, setSearchParams }) {
    const { clickedTagValue, onTourClickedHandler } = useToursContext();
    const [isOpen, setIsOpen] = useState(false);
    const [timer, setTimer] = useState(null)
    const textFieldteRef = useRef();

    let filters = { types: clickedTagValue?.map(tag => tag.type) }
    let queryParams = filters.types.length !== 0 ? JSON.stringify(filters) : null

    const { isFetching, data } = useQuery({
        queryKey: ['map-tours', clickedTagValue],
        queryFn: () => getMapTours(queryParams),
    });

    function handleChangeUserLocation(value) {
        let inputValue = value
        if (inputValue?.length > 1 && inputValue?.length < 21) {
            clearTimeout(timer)
            const newTimer = setTimeout(async () => {
                setSearchParams(inputValue)
            }, 500)
            setTimer(newTimer)
        } else if (inputValue?.length < 1) {
            setSearchParams()
            setIsOpen(false)
            // refetch()
        }
    }

    return (
        <Autocomplete
            sx={{ width: { xs: 180, md: 200 }, m: '4px' }}
            options={data ?? []}

            // filterOptions={(options, state) => state.inputValue !== '' ? options?.find(x => x?.tags?.map(x => x?.name?.includes(state.inputValue))) ?? options : options}
            // filterOptions={(x) => x}
            noOptionsText={'Няма намерени обекти'}
            getOptionLabel={option => option?.title}
            isOptionEqualToValue={(option, value) => value?.id === option?.id}
            loading={isFetching}
            open={isOpen}
            // freeSolo
            popupIcon={false}
            forcePopupIcon={false}
            openOnFocus
            onOpen={() => { setIsOpen(true); }}
            onClose={() => { setIsOpen(false); }}
            onInputChange={(event, value, reason) => {
                // if (reason === 'clear') {
                //     setSearchParams()
                //     refetch()
                // }
                handleChangeUserLocation(value)
            }}
            PopperComponent={(props) => (
                <Popper anchorEl={textFieldteRef?.current} {...props}
                    modifiers={[{ name: 'flip', options: { fallbackPlacements: [] }, },]}
                    popperOptions={{ placement: 'bottom', }}
                />
            )}
            onChange={(e, value) => { value?.id && onTourClickedHandler(value?.id); }}
            renderInput={(params) => (
                <TextField
                    variant={"standard"}
                    size="small"
                    ref={textFieldteRef}
                    sx={{
                        background: 'white', borderRadius: '16px',
                        borderBottomLeftRadius: isOpen && 0, borderBottomRightRadius: isOpen && 0, pb: isOpen && 1,
                        '.MuiAutocomplete-endAdornment': {
                            right: 5
                        },
                        '.MuiInputBase-root': {
                            color: 'black', mt: 0,
                            pl: 1,
                        },
                        '.MuiInputBase-input': {
                            pl: 2,
                            color: 'black', fontWeight: 300,
                            border: 'unset'
                        },
                        // '.MuiFormLabel-root': {
                        //     left: 8, bottom: isOpen ? 33 : 27, top: 'unset',
                        //     textTransform: 'uppercase', pl: 1,
                        //     fontSize: 11, bgcolor: 'rgb(255 255 255 / 90%)', color: 'black'
                        // },
                        '& .MuiInputLabel-root.MuiInputLabel-shrink': { display: 'none', }
                    }}
                    {...params}
                    placeholder={t`Потърси обект`}
                    InputProps={{
                        ...params.InputProps,
                        "aria-label": 'none',
                        disableUnderline: true,
                        startAdornment: (
                            <InputAdornment position='start'>
                                <SearchOutlined color='gray' />
                            </InputAdornment>
                        )
                    }}
                />
            )}
        />
        // </Box>
    );
}